"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZIndex = void 0;
exports.ZIndex = {
  Notifications: 10000,
  DevTools: 9999,
  Overlays: 1000,
  StickyHeaders: 999
};